export default {
    apiUrl: process.env.VUE_APP_API_URL,
    apiUrlTv: process.env.VUE_APP_API_URL_TV,
    apiUrlSearch: process.env.VUE_APP_API_URL_SEARCH,
    apiUrlGuest: process.env.VUE_APP_API_URL_GUEST,
    apiUrlToken: process.env.VUE_APP_API_URL_TOKEN,
    apiUrlConnect: process.env.VUE_APP_API_URL_CONNECT,
    apiUrlLogout: process.env.VUE_APP_API_URL_LOGOUT,
    apiUrlSession: process.env.VUE_APP_API_URL_SESSION,
    apiUrlDetail: process.env.VUE_APP_API_URL_DETAIL,
    apiKey: process.env.VUE_APP_KEY_API
}